export const CONTACT = {
  whatsapp: "+91 6353483140",
  whatsappRaw: "916353483140",
  email: "sales@babulcorporation.co.in",
  phone: "+91 6353483140",
  cityCountry: "94, 95 Ashraf Nagar, Junabazar, Karjan, Vadodara, Gujarat, India",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Process", href: "#process" },
  { label: "Markets", href: "#markets" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const WHY_CHOOSE = [
  { icon: "ShieldCheck", title: "Genuine Products", desc: "Authentic branded FMCG products sourced through authorized distribution channels." },
  { icon: "Repeat", title: "Reliable Supply", desc: "Consistent product availability for repeat orders and long-term partnerships." },
  { icon: "Layers", title: "Multi-Brand Procurement", desc: "Source multiple Indian brands from a single, trusted supplier." },
  { icon: "TrendingDown", title: "Competitive Export Pricing", desc: "Optimized sourcing pipelines for better landed costs at destination." },
  { icon: "Container", title: "Mixed Container Shipments", desc: "Combine multiple brands and product categories in one consolidated shipment." },
  { icon: "FileCheck2", title: "Export Documentation", desc: "Complete paperwork support for international shipments — invoice, packing, COO." },
  { icon: "BadgeCheck", title: "Quality Inspection", desc: "Every consignment is inspected for authenticity, freshness and packaging before dispatch." },
  { icon: "Headphones", title: "Dedicated Support", desc: "Quick, personal communication before, during and after every shipment." },
];

export const IMPORTER_CHALLENGES = [
  { text: "Fake or counterfeit branded products" },
  { text: "Inconsistent supply & stock-outs" },
  { text: "Juggling multiple suppliers per brand" },
  { text: "Slow, unpredictable communication" },
  { text: "Incomplete export documentation" },
  { text: "Frequent shipment delays" },
  { text: "Difficult procurement across categories" },
];

export const BABUL_SOLUTIONS = [
  "Authorized-channel sourcing with authenticity guaranteed",
  "Repeatable, consistent supply pipeline for scaling buyers",
  "One point of contact — dozens of Indian brands under one roof",
  "Response within business-day; dedicated account manager",
  "End-to-end export documentation handled in-house",
  "Coordinated logistics with reliable freight partners",
  "Mixed containers across categories — one shipment, many brands",
];

export const CATEGORIES = [
  {
    id: "atta",
    title: "Atta & Flour",
    brands: ["Aashirvaad Atta", "Multigrain Atta", "Besan", "Sooji"],
    img: "https://images.unsplash.com/photo-1610725664285-7c57e6eeac3f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHx3aGVhdCUyMGZsb3VyfGVufDB8fHx8MTc4MzUwMjY1OHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "biscuits",
    title: "Biscuits & Cookies",
    brands: ["Sunfeast Marie", "Dark Fantasy", "Mom's Magic", "Digestive"],
    img: "https://images.pexels.com/photos/5985991/pexels-photo-5985991.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "instant",
    title: "Instant Foods",
    brands: ["Yippee Noodles", "Pasta"],
    img: "https://images.unsplash.com/photo-1612929633738-8fe44f7ec841?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxpbnN0YW50JTIwbm9vZGxlc3xlbnwwfHx8fDE3ODM1MDI2NTh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "snacks",
    title: "Snacks & Namkeen",
    brands: ["Bingo Chips", "Mad Angles", "Tedhe Medhe"],
    img: "https://images.unsplash.com/photo-1542838132-92c53300491e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxncm9jZXJ5JTIwcHJvZHVjdHN8ZW58MHx8fHwxNzgzNTAyNjM2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "personal",
    title: "Personal Care",
    brands: ["Fiama", "Savlon"],
    img: "https://images.pexels.com/photos/7670737/pexels-photo-7670737.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "beverages",
    title: "Fruit Beverages",
    brands: ["B Natural"],
    img: "https://images.unsplash.com/photo-1600271886742-f049cd451bba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxmcnVpdCUyMGp1aWNlfGVufDB8fHx8MTc4MzUwMjY1MHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "confectionery",
    title: "Confectionery",
    brands: ["Candyman"],
    img: "https://images.unsplash.com/photo-1610450949065-1f2841536c88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxjaG9jb2xhdGVzfGVufDB8fHx8MTc4MzUwMjY1MHww&ixlib=rb-4.1.0&q=85",
  },
];

export const INDUSTRIES = [
  { icon: "Store", label: "Indian Grocery Stores" },
  { icon: "Ship", label: "Importers" },
  { icon: "Warehouse", label: "Wholesale Distributors" },
  { icon: "ShoppingCart", label: "Supermarket Chains" },
  { icon: "ShoppingBag", label: "Retail Chains" },
  { icon: "PackageOpen", label: "Cash & Carry" },
  { icon: "Globe2", label: "Ethnic Food Importers" },
  { icon: "UtensilsCrossed", label: "Food Service Companies" },
];

export const PROCESS_STEPS = [
  { n: "01", title: "Product Inquiry", desc: "Share your product list, quantities and destination port." },
  { n: "02", title: "Requirement Discussion", desc: "A dedicated export manager understands your requirements in detail." },
  { n: "03", title: "Quotation", desc: "Transparent FOB / CIF quote with clear terms and lead time." },
  { n: "04", title: "Order Confirmation", desc: "Advance received, formal PI issued, production plan locked." },
  { n: "05", title: "Procurement", desc: "Products sourced through authorized distribution channels." },
  { n: "06", title: "Quality Inspection", desc: "Batch, MRP, freshness, MFG date and packaging verified." },
  { n: "07", title: "Export Documentation", desc: "Invoice, packing list, COO, phyto/FSSAI as applicable." },
  { n: "08", title: "Container Loading", desc: "Consolidated / mixed container loaded and sealed under supervision." },
  { n: "09", title: "International Shipping", desc: "Coordinated with reputed freight forwarders to your port." },
  { n: "10", title: "Delivery Support", desc: "Real-time tracking and post-arrival documentation assistance." },
];

export const MARKETS = [
  { name: "USA", x: 22, y: 40 },
  { name: "Canada", x: 24, y: 30 },
  { name: "United Kingdom", x: 47, y: 33 },
  { name: "Australia", x: 84, y: 76 },
  { name: "New Zealand", x: 92, y: 82 },
  { name: "UAE", x: 61, y: 49 },
  { name: "Saudi Arabia", x: 59, y: 50 },
  { name: "Qatar", x: 62, y: 48 },
  { name: "Oman", x: 63, y: 52 },
  { name: "Kuwait", x: 60, y: 46 },
  { name: "Bahrain", x: 61, y: 47 },
  { name: "Singapore", x: 76, y: 62 },
  { name: "Malaysia", x: 75, y: 60 },
  { name: "South Africa", x: 54, y: 78 },
  { name: "Kenya", x: 58, y: 66 },
  { name: "Tanzania", x: 58, y: 70 },
  { name: "Mauritius", x: 62, y: 73 },
  { name: "Fiji", x: 96, y: 70 },
];

export const TESTIMONIALS = [
  {
    quote: "Babul Corporation has been our most reliable partner for Indian FMCG sourcing. Mixed containers with Aashirvaad, Sunfeast and Bingo — delivered on time, every time.",
    name: "Rajesh Patel",
    role: "Purchase Director",
    company: "Global Indian Grocers",
    country: "Toronto, Canada",
    img: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4MzUwMjYzNXww&ixlib=rb-4.1.0&q=85",
  },
  {
    quote: "Communication is fast and documentation is always flawless. We've been importing quarterly and never faced a customs issue thanks to their paperwork.",
    name: "Priya Sharma",
    role: "Head of Procurement",
    company: "South Asia Foods LLC",
    country: "Dubai, UAE",
    img: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4MzUwMjYzNXww&ixlib=rb-4.1.0&q=85",
  },
  {
    quote: "Being able to combine 12 different brands in one container has transformed our margins. Babul is now our single-point sourcing partner for India.",
    name: "David Nair",
    role: "CEO",
    company: "Spice Route Distributors",
    country: "Sydney, Australia",
    img: "https://images.pexels.com/photos/9623645/pexels-photo-9623645.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const FAQS = [
  { q: "Do you supply mixed containers?", a: "Yes. We consolidate multiple brands and categories (atta, biscuits, snacks, personal care and more) in a single container to optimize your landed cost." },
  { q: "Can I source multiple brands together?", a: "Absolutely. Our core strength is multi-brand procurement — one PI, one shipment, dozens of Indian brands." },
  { q: "Which countries do you export to?", a: "USA, Canada, UK, Australia, New Zealand, UAE, Saudi Arabia, Qatar, Oman, Kuwait, Bahrain, Singapore, Malaysia, South Africa, Kenya, Tanzania, Mauritius, Fiji and other markets on request." },
  { q: "What is your MOQ?", a: "MOQ is typically one 20ft container (LCL possible for select markets). We tailor MOQ per SKU based on your assortment." },
  { q: "Can you source products not listed on the website?", a: "Yes. The list is representative — we source across major Indian FMCG brands. Share your requirement and we will confirm availability." },
  { q: "Do you provide export documentation?", a: "Complete documentation is included: commercial invoice, packing list, certificate of origin, FSSAI, phytosanitary and any destination-specific paperwork." },
  { q: "How long does shipping take?", a: "Order-to-loading typically 15–25 days depending on assortment. Transit time varies by destination — Middle East 7–12 days, USA/Canada 25–35 days." },
];
